var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHighlighter24Filled = function SvgIconHighlighter24Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 4.65H7.3c-1.46 0-2.65 1.19-2.65 2.65v9.4c0 1.46 1.19 2.65 2.65 2.65h9.4c1.46 0 2.65-1.19 2.65-2.65V7.3c0-1.46-1.19-2.65-2.65-2.65ZM16 9.76h-3.1V16h-1.8V9.76H8v-1.8h8v1.8Z",
    fill: "current"
  })));
};
export default SvgIconHighlighter24Filled;